module.exports = __webpack_public_path__ + "img/back.91c21b28.svg";